"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeAreRequestsActive = exports.makeIsRequestActive = exports.getProgress = exports.areRequestsActive = exports.isRequestActive = void 0;
var reselect_1 = require("reselect");
var activeRequests = function (state) { return state.loading.activeRequests; };
var requestActive = function (requests, request) { return request === undefined
    ? requests.length > 0
    : requests.filter(function (r) { return r === request; }).length > 0; };
var requestsActive = function (requests, queryRequests) { return queryRequests.length === 0
    ? requests.length > 0
    : requests.filter(function (r) { return queryRequests.some(function (q) { return q === r; }); }).length > 0; };
exports.isRequestActive = function (state, request) { return requestActive(activeRequests(state), request); };
exports.areRequestsActive = function (state, requests) {
    if (requests === void 0) { requests = []; }
    return requestsActive(activeRequests(state), requests);
};
exports.getProgress = function (state) { return state.loading.progress; };
exports.makeIsRequestActive = function (request) { return reselect_1.createSelector(activeRequests, function (requests) { return requestActive(requests, request); }); };
exports.makeAreRequestsActive = function (requests) {
    if (requests === void 0) { requests = []; }
    return reselect_1.createSelector(activeRequests, function (r) { return requestsActive(r, requests); });
};
